import React from 'react';
import moment from 'moment';
import { View } from 'react-native';
import { useStyleSheet } from '../../../hooks';
import { createStyleSheet } from '../../../utils';
import { Text } from '../../Text';
export const Weekdays = () => {
    const styles = useStyleSheet(getStyles);
    const weekdays = moment.weekdaysShort();
    return (React.createElement(View, { style: styles.container }, weekdays.map((weekday) => (React.createElement(View, { key: weekday, style: styles.wrapper },
        React.createElement(Text, { type: 'body', size: 'md', weight: 'regular', style: styles.day }, weekday))))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        paddingVertical: size.E
    },
    wrapper: {
        width: size.M,
        alignItems: 'center',
        flexGrow: 1
    },
    day: {
        color: color.invert2.p42
    }
}));
//# sourceMappingURL=WeekDays.js.map